import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements OnInit {
  @Input() formGroupName!: string;
  @Input() hours: string[] = [];

  form!: UntypedFormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    if (!this.formGroupName) {
      throw Error('Attribute "formGroupName" is required');
    }
    this.form = this.rootFormGroup.control.get(
      this.formGroupName
    ) as UntypedFormGroup;
  }

  up(property: string): void {
    this.form.markAsDirty();
    const value = this.form.value;
    const index = this.hours.indexOf(this.form.value[property]);

    if (index + 1 < this.hours.length) {
      this.form.setValue({ ...value, [property]: this.hours[index + 1] });
    } else {
      this.form.setValue({ ...value, [property]: this.hours[0] });
    }
  }

  down(property: string): void {
    this.form.markAsDirty();
    const value = this.form.value;
    const index = this.hours.indexOf(this.form.value[property]);

    if (index - 1 >= 0) {
      this.form.setValue({ ...value, [property]: this.hours[index - 1] });
    } else {
      this.form.setValue({
        ...value,
        [property]: this.hours[this.hours.length - 1],
      });
    }
  }
}
